import { useSelector } from 'react-redux';

import {
  selectPaperworkFlowFormStepNumber,
  selectPaperworkFlowFormStepsCount,
} from '../../../redux/paperwork/selectors/common';

const usePaperworkFlowFormSteps = () => {
  const currentPathname = window.location.pathname;

  const currentStepNumber = useSelector(
    selectPaperworkFlowFormStepNumber(currentPathname),
  );

  const stepsCount = useSelector(selectPaperworkFlowFormStepsCount);

  return {
    currentStepNumber,
    stepsCount,
  };
};

export default usePaperworkFlowFormSteps;



// WEBPACK FOOTER //
// ./src/components/Paperwork/hooks/usePaperworkFlowFormSteps.js